import { CloseCircleOutlined } from '@ant-design/icons';
import { Center, IconButton, Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { ReactNode, useEffect, useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  allowZoom?: boolean;
  content: ReactNode;
};

export const SimpleContentModal = ({
  content,
  isOpen = true,
  allowZoom = true,
  onClose,
}: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(isOpen);

  // update on props change also
  useEffect(() => {
    setModalOpen(isOpen);
  }, [isOpen]);

  return (
    <Modal
      isCentered
      size="full"
      scrollBehavior="inside"
      motionPreset="scale"
      closeOnOverlayClick
      isOpen={modalOpen}
      onClose={() => {
        setModalOpen(false);
        onClose?.();
      }}
    >
      <ModalOverlay bgColor="blackAlpha.900" />
      <ModalContent
        bg="transparent"
        borderRadius="20px"
        maxW="100%"
        width="100%"
        maxH="90vh"
        height="85vh"
      >
        <ModalBody>
          <Center py="15px" px="15px" width="100%" height="100%">
            <TransformWrapper disabled={!allowZoom} centerOnInit={true}>
              <TransformComponent wrapperStyle={{ width: '100%', height: '100%' }}>
                {content}
              </TransformComponent>
            </TransformWrapper>
          </Center>
        </ModalBody>
        {/* <ModalCloseButton color="white" /> */}
        <IconButton
          position="absolute"
          top={0}
          right={0}
          role="button"
          boxSize="80px"
          fontSize="40px"
          borderRadius="full"
          color="white"
          aria-label="close"
          variant="unstyled"
          icon={<CloseCircleOutlined />}
          onClick={onClose}
          userSelect="none"
          _focusVisible={{ border: 'none' }}
        />
      </ModalContent>
    </Modal>
  );
};
